@if (form$ | async; as form) {
  <igo-form
    [form]="form"
    [formData]="data$ | async"
    (submitForm)="onSubmit($any($event))"
  >
    @if (form.fields.length) {
      <div class="form-container">
        @for (field of form.fields; track field) {
          <igo-form-field [field]="field" />
        }
      </div>
    }
    <div formButtons class="actions-container">
      <button
        mat-stroked-button
        type="button"
        color="primary"
        (click)="clearForm()"
      >
        {{ 'igo.integration.dataIssueReporterTool.reset.button' | translate }}
      </button>
      <button
        matButton="filled"
        type="submit"
        color="primary"
        [disabled]="submitDisabled"
      >
        {{ 'igo.integration.dataIssueReporterTool.submit.button' | translate }}
      </button>
    </div>
  </igo-form>
}
